// Schreibt die ausgewählten Importzeilen. Vorhandene Eigentümer werden nicht doppelt angelegt,
// sondern nur dem erkannten Objekt zugeordnet (wie bisher). Zuordnungen nur additiv über
// setzeObjektEigentuemer (idempotent) – nichts wird gelöscht.

import { supabase } from '../supabase/client';
import { alleSeiten } from '../supabase/alleSeiten';
import { setzeObjektEigentuemer } from './verknuepfung';
import { eigentuemerDatensatz, findeVorhanden, importName, type BestehenderEig, type VorschauZeile } from './csvImport';

export interface ImportErgebnis {
  erstellt: number;
  zuordnungen: number;
  uebersprungen: number;
  meldungen: string[];
}

export async function importiereEigentuemer(auswahl: readonly VorschauZeile[], abgewaehlt: number): Promise<ImportErgebnis> {
  const ergebnis: ImportErgebnis = { erstellt: 0, zuordnungen: 0, uebersprungen: abgewaehlt, meldungen: [] };
  // frisch laden: seit der Vorschau könnte jemand denselben Eigentümer angelegt haben
  const bestehende: BestehenderEig[] = await alleSeiten<BestehenderEig>((von, bis) =>
    supabase.from('eigentuemer').select('id, vorname, nachname, firma_name, email').order('id').range(von, bis));

  for (const v of auswahl) {
    const name = importName(v.zeile);
    try {
      const vorhanden = findeVorhanden(v.zeile, bestehende);
      if (vorhanden) {
        if (v.objekt) {
          const { neuVerknuepft } = await setzeObjektEigentuemer(v.objekt.id, vorhanden.id);
          if (neuVerknuepft) ergebnis.zuordnungen++;
        }
        ergebnis.uebersprungen++;
        ergebnis.meldungen.push(`${name} existiert bereits`);
        continue;
      }
      const { data, error } = await supabase.from('eigentuemer').insert([eigentuemerDatensatz(v.zeile)]).select('id').single<{ id: string }>();
      if (error || !data) {
        ergebnis.uebersprungen++;
        ergebnis.meldungen.push(`${name}: ${error?.message ?? 'nicht angelegt'}`);
        continue;
      }
      ergebnis.erstellt++;
      bestehende.push({ id: data.id, vorname: v.zeile.vorname, nachname: v.zeile.nachname, firma_name: v.zeile.firma_name, email: v.zeile.email });
      if (v.objekt) {
        await setzeObjektEigentuemer(v.objekt.id, data.id);
        ergebnis.zuordnungen++;
      }
    } catch (e) {
      ergebnis.uebersprungen++;
      ergebnis.meldungen.push(`${name}: ${e instanceof Error ? e.message : 'Unbekannter Fehler'}`);
    }
  }
  return ergebnis;
}
